import { createAction, props } from '@ngrx/store';

export const getCountries = createAction('[Countries] Get countries', props<any>());
export const countriesFailure = createAction('[Countries] Countries failed', props<any>());
export const countriesSuccess = createAction('[Countries] Countries sucess', props<any>());


export const logout = createAction('[User] Logout');
